import { useEffect, useState } from 'react';
import { useUnit } from 'effector-react';
import clsx from 'clsx';
import { $transferRequestsApprovedListStore, $transferUpdateStatusStore } from '@lib/store/transferRequests';
import { PaletteUtils } from '@shared/utils';
import { TransferRequestStatusEnum, type TransferRequestResponse } from '@shared/api/rest/transferRequests';
import { ColorsEnum, Icon, NoData, Pagination, Spinner, Text } from '@shared/widgets';
import ShareIcon from '@assets/icons/share3.svg';

interface UpcomingPaymentsProps {
  onSelect: (item: TransferRequestResponse) => void;
}

export const ApprovePayments = (props: UpcomingPaymentsProps) => {
  const transferStore = useUnit($transferRequestsApprovedListStore.store);

  const [count, setCount] = useState(5);
  const [index, setIndex] = useState(1);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    $transferRequestsApprovedListStore.events.update({
      status: TransferRequestStatusEnum.WaitingForApproval,
      FromIndex: (index - 1) * count,
      Count: count,
    });
    $transferUpdateStatusStore.events.clear();
  }, [index, $transferRequestsApprovedListStore, count]);

  useEffect(() => {
    setTotal(transferStore?.data?.total);
  }, [transferStore?.data?.total, index, $transferRequestsApprovedListStore, count]);

  return (
    <div className='flex flex-col bg-white dark:bg-soft-black gap-3 p-6'>
      <Text weight='semibold' size='2xl'>
        Approve new transfers
      </Text>
      {transferStore.loading && <Spinner />}
      {!transferStore.loading && transferStore.data.data.length > 0 && (
        <>
          <div className='mb-auto'>
            {transferStore.data.data.length > 0 &&
              transferStore.data.data.map((element) => (
                <div key={element.id} className='flex items-start justify-start p-3 cursor-pointer' onClick={() => props.onSelect(element)}>
                  <Icon
                    icon={<ShareIcon />}
                    className={clsx(
                      'h-9 w-9 mr-3 rounded-3xl flex-none flex items-center justify-center dark:bg-primary',
                      PaletteUtils.isInsigniaPalette && 'bg-soft-black',
                      PaletteUtils.isVcfcPalette && 'bg-primary',
                    )}
                    color='white'
                  />
                  <div className='flex flex-col items-start justify-start'>
                    <Text>
                      {element?.senderCurrency} {element?.senderAmount?.toLocaleString()}
                    </Text>
                    <Text size='xs' color={ColorsEnum.Gray}>
                      {element.recipient?.name || element.beneficiaryAccount?.name}
                    </Text>
                  </div>
                </div>
              ))}
          </div>
          <Pagination
            currentPage={index}
            onChangeCountItemPage={setCount}
            onChangePage={setIndex}
            countItemPage={count}
            totalItemCount={total}
            noSelect
          />
        </>
      )}
      {!transferStore.loading && transferStore.data.data.length === 0 && <NoData text='No related records' />}
    </div>
  );
};
